import Popover from '@mui/material/Popover/Popover'
import './PopoverLink.scoped.scss'

export default function PopoverLink({ children, content, noQuestionIcon = false, ...rest }) {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    event.preventDefault()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  return (
    <>
      <a href="#" onClick={handleClick} {...rest}>
        {children}
      </a>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div style={{ padding: 15, maxWidth: 360, display: 'flex' }}>
          {!noQuestionIcon &&
            <div style={{ minWidth: 24, marginRight: 10 }}><SvgIconsQuestion /></div>
          }
          <div>{content()}</div>
        </div>
      </Popover>
    </>
  )
}


